import {UPDATE_HEADER_CONTENT} from './actions';

const header = (state = {}, {type, payload}) => {
    let nextState = state;

    if (type === UPDATE_HEADER_CONTENT) {
        nextState = payload;
    }

    return nextState;
};

export default header;
